import React from 'react'

//hooks
import UseAdminDetailsScreen from './AdminDetailsScreen.hooks'

//styling
import "../../../../../css/orgSettings/users/adminDetails.scss";



const AdminDetailsScreen = () => {  
    const {labelText, organisationRole, userRole} = UseAdminDetailsScreen();

    if (!userRole) {
        return <></>
    }
    return(
        <div className="organisational-role" data-testid="admin-details">
            <label htmlFor='orgRole'>{labelText}</label>
            <div id="orgRole" className='org-role-text'>{organisationRole}</div>        
        </div>
    )
}

export default AdminDetailsScreen